import React, { useEffect } from 'react';
//HELPERS
//COMPONENTS
import Input from 'tailwind-components/Input/Input';
import Button from 'tailwind-components/Button/Button';
//EXTERNALS
import useLogin from './useLogin';
import PropTypes from 'prop-types';

// the label is a <p> and no preflight runs, so its browser margins (1em top
// and bottom) opened a wide gap above every input
const LABEL_CLASSES = 'm-0 mb-1.5';

function LoginForm({
  setResolver,
  setUserCredentials,
  setEmailProp,
  setPasswordProp
}) {
  const {
    login,
    isLogIn,
    setEmail,
    setPassword,
    errors,
    resolver,
    userCredentials
  } = useLogin();

  useEffect(() => {
    if (resolver || userCredentials) {
      setResolver(resolver);
      setUserCredentials(userCredentials);
    }
  }, [resolver, userCredentials]);

  return (
    <form className='flex w-full flex-col gap-4'>
      <Input
        name='email'
        label='E-mail'
        labelClassName={LABEL_CLASSES}
        type='mail'
        error={errors.email}
        placeholder='Enter your e-mail'
        onChange={e => {
          if (!e.target.value) return;
          setEmailProp(e.target.value);
          setEmail(e);
        }}
        autoFocus
      />
      <Input
        name='password'
        label='Password'
        labelClassName={LABEL_CLASSES}
        type='password'
        error={errors.password}
        placeholder='Enter your password'
        onChange={e => {
          if (!e.target.value) return;
          setPasswordProp(e.target.value);
          setPassword(e);
        }}
      />
      <Button
        isLoading={isLogIn}
        disabled={isLogIn}
        text='Login'
        variant='primary'
        size='medium'
        rounded='small'
        fill
        className='mt-2'
        onClick={e => {
          e.preventDefault();
          login();
        }}
        type='submit'
      />
    </form>
  );
}

LoginForm.propTypes = {
  setResolver: PropTypes.func,
  setUserCredentials: PropTypes.func,
  setEmailProp: PropTypes.func,
  setPasswordProp: PropTypes.func
};

export default LoginForm;
